import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, GROUP_LIMIT, STATUS } from "../../../Constants";
import axios from "axios";
import { toast } from "react-toastify";


// For Get The Next (All Member Of Group)
const extractGroupMemberNextEndpoint = (args)=>`${DomainName}/group/member?userAccessToken=${args.userToken}&groupId=${args.groupId}&pagingToken=${args.next}&limit=${GROUP_LIMIT}` ;

export const extractGroupMemberNextAPI = createAsyncThunk('extractMember/getNext' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ;
    try{
        const response = await axios.get(extractGroupMemberNextEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data ;
    } catch(error){
        return rejectWithValue(error) ;
    }
})

// For Extract Group member 
const extractGroupMemberEndpoint = (args)=>`${DomainName}/group/member?userAccessToken=${args.userToken}&groupId=${args.groupId}&limit=${GROUP_LIMIT}` ;

export const extractGroupMemberAPI = createAsyncThunk('extractMember/get' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ;
    try{
        const response = await axios.get(extractGroupMemberEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data ;
    } catch(error){
        return rejectWithValue(error) ;
    }
})

const initialState = {
    members : [] , 
    statusMember : STATUS.IDLE , 
    hasNextStatus : STATUS.IDLE , 
    hasNext : ""
}

const extractGroupMemberSlice = createSlice({
    name : "extractMember" , 
    initialState , 
    reducers : {

    } ,
    extraReducers : (builder)=>{
        builder
        // for Get Group Members
        .addCase(extractGroupMemberAPI.fulfilled , (state , action)=>{
            state.members = action.payload.members ;
            state.hasNext = action.payload.nextPageToken
            state.statusMember = STATUS.SUCCESS
        })
        .addCase(extractGroupMemberAPI.pending , (state , action)=>{
            state.statusMember = STATUS.LOADDING
        })
        .addCase(extractGroupMemberAPI.rejected , (state , action)=>{
            toast.error("Something error ") ; 
            state.statusMember = STATUS.ERROR
        })
        // For Get The Next Of Group Members
        .addCase(extractGroupMemberNextAPI.fulfilled , (state , action)=>{
            state.members.push(...action.payload.members) ;
            state.hasNext = action.payload.nextPageToken
            state.hasNextStatus = state.hasNext === null  ? STATUS.SUCCESS : STATUS.LOADDING;
        })
        
    }
})



export default extractGroupMemberSlice.reducer ;



export const getMembersExtracted = state => state.extractGroupMemberSlice ;

export const getTheNextInfo = state => state.extractGroupMemberSlice